// extracted by css-extract-rspack-plugin
export default {"storeDevices":"src-domain-components-sync-configuration-store-modal-SyncConfigurationStoreModal-module__storeDevices-Sp7mfP"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"storeDevices\":\"src-domain-components-sync-configuration-store-modal-SyncConfigurationStoreModal-module__storeDevices-Sp7mfP\"}";
        // 1793705032992
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  